<template>
    <div class="container text-center">
        <p>I am a world champion of sport stacking from Connecticut. Thanks for coming to my site! Be sure to check out the <router-link to="/results">results</router-link> page which contains detailed results of all my competitions. You can also <a :href="youtubeUrl">subscribe to my YouTube channel</a>.</p>
        
        <OverlayEmbed v-if="highlightVideoUrl != null" :src="highlightVideoUrl" aspect="16by9" allowfullscreen />
    </div>
</template>

<script>
import { YOUTUBE_URL } from '@/common/constants.js';
import OverlayEmbed from './OverlayEmbed.vue';

export default {
    data() {
        return {
            youtubeUrl: YOUTUBE_URL,
            highlightVideoUrl: null,
        };
    },
    components: {
        OverlayEmbed
    },
    created() {
        fetch("https://jonscannell-com.firebaseio.com/highlightVideo.json")
            .then(response => response.json())
            .then(highlightVideoUrl => {
                this.highlightVideoUrl = highlightVideoUrl;
            });
    }
}
</script>
